import script from "./PivotPoints.vue?vue&type=script&lang=js"
export * from "./PivotPoints.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__